export const radioGroupType = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
};
